import { IGetPgtoContratoFinanceiroByIdUseCase } from "../../../presentation/useCases/read/get_pgto_contrato_financeiro_by_id_use_case";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";
import { PgtoContratoFinanceiro } from '../../models/pgto_contrato_financeiro';

/**
 * GetPgtoContratoFinanceiroByIdUseCase
 */

export class GetPgtoContratoFinanceiroByIdUseCase implements IGetPgtoContratoFinanceiroByIdUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async getPgtoContratoFinanceiroById(idPgto: number): Promise<PgtoContratoFinanceiro> {
    return await this.repository.getPgtoContratoFinanceiroById(idPgto);

  }
}
